import React from "react";
import Flip from "react-reveal/Flip";

import bismillah from "../assets/bismillah.png";
import line from "../assets/line.png";
import profile from "../assets/profile.jpg";

export default function Main() {
  return (
    <>
      <Flip>
        <div className="container-content">
          <img src={bismillah} width="50%" />
          <i
            className="garamond-font"
            style={{ fontSize: 14, marginTop: 20, color: "black" }}
          >
            Assalamu'alaikum Warahmatullahi Wabarakatuh
          </i>
          <p
            className="garamond-font"
            style={{ fontSize: 14, color: "black", marginTop: 10 }}
          >
            Dengan memohon rahmat dan ridho Allah SWT, Mohon do'a restu
            Bapak/Ibu/Saudara/i dalam rangka melangsungkan pernikahan
            putra-putri kami:
          </p>
          <div style={{ display: "flex", marginTop: 10 }}>
            <div className="image-profile-container">
              <img
                src={profile}
                objectfit="cover"
                width="100%"
                height="100%"
                style={{ borderRadius: "50%" }}
              />
            </div>
          </div>
          <p
            className="playball-font"
            style={{ fontSize: 20, color: "#cc9933", margin: "20px 10px 10px" }}
          >
            Ardina Sovitasari, S.Kom
          </p>
          <img src={line} width={180} />
          <i
            className="playball-font"
            style={{ fontSize: 18, color: "black", margin: "10px 0px 5px" }}
          >
            Putri Ketiga
          </i>
          <p className="garamond-font" style={{ fontSize: 16, color: "black" }}>
            Alm. Bapak Djoko Saptono
          </p>
          <p className="garamond-font" style={{ fontSize: 16, color: "black" }}>
            Ibu Mei Hastuti
          </p>
          <i
            className="garamond-font"
            style={{ fontSize: 30, color: "black", marginTop: "10px" }}
          >
            &
          </i>
          <div style={{ display: "flex" }}>
            {/* <div className="image-profile-container">
              <img
                src={ganang}
                objectfit="cover"
                width="100%"
                height="100%"
                style={{ borderRadius: "50%" }}
              />
            </div> */}
          </div>
          <p
            className="playball-font"
            style={{ fontSize: 20, color: "#cc9933", margin: "10px 10px 10px" }}
          >
            Ganang Bagus Prakoso, S.Kom
          </p>
          <img src={line} width={180} />
          <i
            className="playball-font"
            style={{ fontSize: 18, color: "black", margin: "10px 0px 5px" }}
          >
            Putra Pertama
          </i>
          <p className="garamond-font" style={{ fontSize: 16, color: "black" }}>
            Bapak Tunggul Marwata
          </p>
          <p className="garamond-font" style={{ fontSize: 16, color: "black" }}>
            Ibu Pulung Tri Heronusa
          </p>
        </div>
      </Flip>
    </>
  );
}
